import {
  AspectRatio,
  Box,
  Button,
  Card,
  Flex,
  Icon,
  IconProps,
  Stack,
  Text,
} from '@chakra-ui/react';
import { trackEvent } from '@diamond/shared/utils';
import { TRACKING_EVENTS, TRACKING_PAGES } from '@diamond/sol-buyer/constant';
import Link from 'next/link';

import { Image } from '../common';

type Promo = {
  id: string;
  duration: string;
  img: string | null;
  title: string;
  mechanism: string | null;
  termsAndCondition: string | null;
};

type CardPromoProps = {
  data: Promo;
};

export function CardPromo({ data }: CardPromoProps) {
  // const section = `Promo Highlight | ${data?.title} | ${data?.mechanism}`;
  const section = `Promo Highlight`;

  return (
    <Card p={{ base: '2', lg: '4' }} h="full" display="flex">
      <Stack px="4" py="2" direction="row" bg="red" color="white" rounded="md">
        <LightningIcon
          flex={{ base: '0 0 16px', lg: '0 0 24px' }}
          fontSize={{ base: '16px', lg: '24px' }}
        />
        <Text fontWeight="bold" fontSize={{ base: 'xs', lg: 'md' }}>
          {data.duration}
        </Text>
      </Stack>
      <AspectRatio
        position="relative"
        overflow="hidden"
        mt="3"
        ratio={1312 / 512}
      >
        <Image
          src={data.img || ''}
          alt="Promo"
          fill
          sizes="(max-width: 768px) 160px, 188px"
          style={{
            objectFit: 'cover',
          }}
          fallbackSrc="/images/placeholder_promo.jpg"
        />
      </AspectRatio>
      <Box flex="1" mt="2" px="2" py="3">
        <Text fontWeight="bold" fontSize={{ base: 'sm', lg: 'lg' }} mb="3">
          {data.title}
        </Text>
        <Text
          noOfLines={{ base: 5, lg: 3 }}
          fontSize={{ base: 'sm', lg: 'md' }}
        >
          {data.mechanism}
        </Text>
        <Text
          mt="4"
          noOfLines={{ base: 2, lg: 2 }}
          fontSize={{ base: 'xs', lg: 'sm' }}
          dangerouslySetInnerHTML={{
            __html: data.termsAndCondition?.replace(/\n/g, '<br/>') || '',
          }}
        />
      </Box>
      <Flex gap="2" mt="2">
        <Button
          as={Link}
          onClick={() =>
            trackEvent(TRACKING_EVENTS.CLICK_PROMO_OTHERS, {
              promo_id: data.id,
              promo_name: data.title,
              section_name: section,
              page_name: TRACKING_PAGES.BERANDA,
              item_list_id: section,
            })
          }
          href="/promo"
          w="full"
          variant="outline"
          size="sm"
          fontSize={{ base: '12px', md: '14px' }}
        >
          Promo Lainnya
        </Button>
        <Button
          as={Link}
          onClick={() =>
            trackEvent(TRACKING_EVENTS.CLICK_PROMO_DETAIL, {
              promo_id: data.id,
              promo_name: data.title,
              section_name: section,
              page_name: TRACKING_PAGES.BERANDA,
            })
          }
          href={`/promo/${data.id}`}
          w="full"
          bg="blue"
          color="white"
          variant="solid"
          size="sm"
          fontSize={{ base: '12px', md: '14px' }}
          _hover={{
            bg: 'navy',
          }}
        >
          Lihat Detail Promo
        </Button>
      </Flex>
    </Card>
  );
}

const LightningIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3425 0.832771C15.6408 0.98586 15.8012 1.31834 15.7354 1.64711L14.3605 8.52172L19.7634 10.5478C19.9978 10.6357 20.1729 10.8349 20.2302 11.0786C20.2874 11.3224 20.2192 11.5787 20.0483 11.7618L9.5483 23.0118C9.31953 23.2569 8.95586 23.3204 8.65757 23.1673C8.35927 23.0142 8.19882 22.6817 8.26458 22.3529L9.6395 15.4783L4.23667 13.4523C4.0022 13.3643 3.82708 13.1652 3.76986 12.9214C3.71263 12.6776 3.78086 12.4214 3.95172 12.2383L14.4517 0.988289C14.6805 0.743176 15.0442 0.679681 15.3425 0.832771ZM5.81373 12.4417L10.7634 14.2978C11.1076 14.4269 11.3076 14.7866 11.2354 15.1471L10.2533 20.0581L18.1863 11.5584L13.2367 9.70227C12.8924 9.57316 12.6925 9.2135 12.7646 8.85294L13.7468 3.94198L5.81373 12.4417Z"
      fill="currentColor"
    />
  </Icon>
);
